'use client';

import type { UseFormReturn } from 'react-hook-form';
import type { ContactPriceFormValues } from './contact-price-schema';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../../ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

interface FormFooterProps {
  step: number;
  setStep: (step: number) => void;
  form: UseFormReturn<ContactPriceFormValues>;
}

export function FormFooter({ step, form, setStep }: FormFooterProps) {
  const { t } = useTranslations();

  return (
    <div className="flex w-full items-center justify-end gap-4">
      {step === 1 && <Button type="button" onClick={() => setStep(2)}>{t('text1027')}</Button>}
      {step === 2 && (
        <>
          <Button type="button" variant={'primary-foreground'} onClick={() => setStep(1)}>
            {t('text1026')}
          </Button>
          <Button
            type="submit"
            className={cn('ea-contact-price-form__submit')}
            isLoading={form.formState.isSubmitting}
          >
            {t('text1041')}
          </Button>
        </>
      )}
    </div>
  );
}
